import { alpha, Box, Paper, Typography } from "@mui/material";
import { CorrespondenceResponse } from "../../../services/agent.service";
import { ProductMetadata } from "./types";
import { AttachedFiles, CreatedBy, CrmProductInfo, InfoRow, ProductStatus, Section } from "./common";
import { format } from "date-fns";

const CorrespondenceDetails: React.FC<{
  productInfo: CorrespondenceResponse;
  productMetaData: ProductMetadata;
  onProductUpdate: (product: CorrespondenceResponse) => void;
}> = ({ productInfo, productMetaData, onProductUpdate }) => {
  const { createdBy, product } = productInfo;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <CrmProductInfo productCrm={productInfo.productCrm} />

      {/* Basic Info */}
      <Section title="Details">
        <InfoRow label="Created at" value={format(product.createdAt, "yyyy-MM-dd HH:mm")} />
        <InfoRow label="Updated at" value={format(product.updatedAt, "yyyy-MM-dd HH:mm")} />
        <InfoRow label="Product Request ID" value={product.productRequestId} />
        <InfoRow label="Transaction ID" value={product.transactionId} />
        <InfoRow label="PDF URL" value={product.pdfUrl} />
      </Section>

      {/* Client Details */}
      <Section title="Client Details">
        <InfoRow label="Full Name" value={product.fullName} />
        <InfoRow label="Email" value={product.email} />
        <InfoRow label="User ID (DB)" value={product.userId} />
        <InfoRow label="User ID (CRM)" value={product.crmProfileId} />
      </Section>

      {/* Created By */}
      <CreatedBy createdBy={createdBy} />

      {/* Form Data */}
      {product.formData?.correspondence && Object.keys(product.formData.correspondence).length > 0 && (
        <Section title="Form Data">
          {Object.entries(product.formData.correspondence).map(([key, value]) => (
            <InfoRow key={key} label={key.charAt(0).toUpperCase() + key.slice(1)} value={typeof value === "object" ? JSON.stringify(value) : value} />
          ))}
        </Section>
      )}

      {/* Attached Files */}
      <AttachedFiles attachments={productInfo.attachments} productMetaData={productMetaData} />

      {/* Error */}
      {product.error && (
        <Paper sx={{ p: 2, bgcolor: alpha("#f44336", 0.1), border: `1px solid ${alpha("#f44336", 0.2)}`, borderRadius: 1.5, overflowX: "auto" }}>
          <Typography variant="subtitle2" sx={{ color: "#d32f2f", mb: 1, fontSize: "0.85rem" }}>
            Error
          </Typography>
          <Typography variant="caption" sx={{ color: "#d32f2f" }}>
            {product.error}
          </Typography>
        </Paper>
      )}

      {/* Process Status */}
      <ProductStatus productInfo={productInfo} productMetaData={productMetaData} onProductUpdate={onProductUpdate} />
    </Box>
  );
};

export default CorrespondenceDetails;
